import React from "react";
import { styled } from "@mui/material/styles";
import { InternalStandardProps, Box, BoxProps } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppTypography } from "./AppTypography";

const Root = styled(Box)(({ theme }) => ({
    textAlign: "center",
    color: `${theme.palette.grey[400]}`,
}));

const FolderIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    height: "80px",
    color: `${theme.palette.grey[400]}`,
}));

export interface AppNoDataFoundProps extends InternalStandardProps<BoxProps> {
    notFoundText: string;
}

export const AppNoDataFound = (props: AppNoDataFoundProps) => {
    const { className, notFoundText } = props;
    return (
        <Root className={className}>
            <FolderIcon icon={["far", "folder-closed"]} />
            <AppTypography variant="body1">{notFoundText}</AppTypography>
        </Root>
    );
};
